import * as s from './style'
import { ImLoop2 } from 'react-icons/im';
import { IoIosPaper } from 'react-icons/io';
import Transitions from '../../transitions'

function ContainerRight(){

    const arr = [{
        name: 'Paula',
        type: 'Plano 2',
        price: 46,
        icon: <ImLoop2/>
    },
    {
        name: 'Francisco',
        type: 'Boleto',
        price: 756,
        icon: <IoIosPaper/>
    },
    {
        name: 'Francisco',
        type: 'Plano 3',
        price: 88,
        icon: <ImLoop2/>
    },
    {
        name: 'Francisco',
        type: 'Plano 2',
        price: 88,
        icon: <ImLoop2/>
    }]

    return(
        <s.container>
            <div className='recent-transitions'>
                <h3>Últimas transações</h3>
                {arr.map((item, index) =>{
                    return <Transitions
                        icon={item.icon}
                        name={item.name}
                        type={item.type}
                        price={item.price}
                        key={index}
                    />
                })}
            </div>
            <div className='container-question'>
                <div className='container-text'>
                    <h3>{'Precisa de ajuda ?'}</h3>
                    <p>Diga-nos o que precisa...</p>
                </div>
                <img src='https://img.freepik.com/free-vector/questions-concept-illustration_114360-1513.jpg?size=338&ext=jpg' loading='lazy' alt="" />
            </div>
        </s.container>
    )
}

export default ContainerRight